import { useCallback, useEffect, useState } from "react";

export function getFullscreenElement() {
  return (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement ||
    null
  );
}

export async function enterFullscreen() {
  const el = document.documentElement;
  if (el.requestFullscreen) await el.requestFullscreen();
  else if (el.webkitRequestFullscreen) await el.webkitRequestFullscreen();
  else if (el.mozRequestFullScreen) await el.mozRequestFullScreen();
  else if (el.msRequestFullscreen) await el.msRequestFullscreen();
}

export async function exitFullscreen() {
  if (document.exitFullscreen) await document.exitFullscreen();
  else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
  else if (document.mozCancelFullScreen) await document.mozCancelFullScreen();
  else if (document.msExitFullscreen) await document.msExitFullscreen();
}

export function useFullscreenState() {
  const [fullscreenActive, setFullscreenActive] = useState(() =>
    !!getFullscreenElement()
  );

  useEffect(() => {
    const sync = () => setFullscreenActive(!!getFullscreenElement());
    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    document.addEventListener("mozfullscreenchange", sync);
    document.addEventListener("MSFullscreenChange", sync);
    return () => {
      document.removeEventListener("fullscreenchange", sync);
      document.removeEventListener("webkitfullscreenchange", sync);
      document.removeEventListener("mozfullscreenchange", sync);
      document.removeEventListener("MSFullscreenChange", sync);
    };
  }, []);

  const toggleFullscreen = useCallback(async () => {
    try {
      if (getFullscreenElement()) await exitFullscreen();
      else await enterFullscreen();
    } catch (e) {
      console.warn("Tela cheia indisponível:", e);
    }
  }, []);

  return { fullscreenActive, toggleFullscreen };
}
